import {Action} from 'redux'
import {AuctionTypeModel} from '../Model/Model'
import {actionTypes} from './constants'

export interface ActionWithPayload<T> extends Action {
  payload?: T
}

const initialAuctionTypeState: IAuctionTypeState = {
  data: {
    auctionType: [],
    meta: [],
  },
  sortAuctionTypeData: [],
  auctionTypeList: {auctionType: []},
  deleteSuccess: false,
  enableSuccess: false,
  disableSuccess: false,
  singleEnableSuccess: false,
  singleDisableSuccess: false,
  loading: false,
  success: false,
}

export interface IAuctionTypeState {
  data?: {
    auctionType?: AuctionTypeModel[]
    meta?: {[key: string]: string | number}[]
  }
  sortAuctionTypeData?: IAuctionTypeState[]
  auctionTypeList?: {auctionType: AuctionTypeModel[]}
  deleteSuccess?: boolean
  enableSuccess?: boolean
  disableSuccess?: boolean
  singleEnableSuccess?: boolean
  singleDisableSuccess?: boolean
  loading?: boolean
  success?: boolean
}

export const reducer = (
  state: IAuctionTypeState = initialAuctionTypeState,
  action: ActionWithPayload<IAuctionTypeState>
) => {
  switch (action.type) {
    case actionTypes.GET_ALL_AUCTION_TYPE_START: {
      return {...state, loading: true}
    }

    case actionTypes.GET_ALL_AUCTION_TYPE_SUCCESS: {
      return {
        ...state,
        data: action.payload,
        auctionTypeList: action.payload,
        loading: false,
      }
    }

    case actionTypes.GET_ALL_AUCTION_TYPE_FINISH: {
      const error = action.payload
      return {...state, error, loading: false}
    }

    //GET AuctionType DATA
    case actionTypes.GET_AUCTION_TYPE_START: {
      return {...state, loading: true}
    }

    case actionTypes.GET_AUCTION_TYPE_SUCCESS: {
      return {...state, data: action.payload, loading: false}
    }

    case actionTypes.GET_AUCTION_TYPE_FINISH: {
      const error = action.payload
      return {...state, error, loading: false}
    }

    //Add AuctionType
    case actionTypes.ADD_AUCTION_TYPE_START: {
      return {...state, loading: true}
    }

    case actionTypes.ADD_AUCTION_TYPE_SUCCESS: {
      return {
        ...state,
        data: action?.payload?.data,
        success: true,
        loading: false,
      }
    }

    case actionTypes.ADD_AUCTION_TYPE_FINISH: {
      const error = action.payload
      return {...state, error, loading: false}
    }

    case actionTypes.RESET_AUCTION_TYPE: {
      return {
        ...state,
        data: [],
        success: false,
      }
    }

    //Update AuctionType
    case actionTypes.UPDATE_AUCTION_TYPE_START: {
      return {...state, loading: true}
    }

    case actionTypes.UPDATE_AUCTION_TYPE_SUCCESS: {
      return {
        ...state,
        data: action?.payload?.data,
        success: true,
        loading: false,
      }
    }

    case actionTypes.UPDATE_AUCTION_TYPE_FINISH: {
      const error = action.payload
      return {...state, error, loading: false}
    }

    //Delete
    case actionTypes.DELETE_AUCTION_TYPE_START: {
      return {...state, loading: true}
    }

    case actionTypes.DELETE_AUCTION_TYPE_SUCCESS: {
      return {
        ...state,
        deleteSuccess: true,
        loading: false,
      }
    }

    case actionTypes.DELETE_AUCTION_TYPE_FINISH: {
      return {
        ...state,
        loading: false,
        deleteSuccess: false,
      }
    }

    //Enable
    case actionTypes.ENABLE_AUCTION_TYPE_REQUEST: {
      return {...state, loading: true}
    }

    case actionTypes.ENABLE_AUCTION_TYPE_SUCCESS: {
      return {
        ...state,
        enableSuccess: true,
        loading: false,
      }
    }

    case actionTypes.ENABLE_AUCTION_TYPE_FINISH: {
      return {
        ...state,
        loading: false,
        enableSuccess: false,
      }
    }

    //disable
    case actionTypes.DISABLE_AUCTION_TYPE_REQUEST: {
      return {...state, loading: true}
    }

    case actionTypes.DISABLE_AUCTION_TYPE_SUCCESS: {
      return {
        ...state,
        disableSuccess: true,
        loading: false,
      }
    }

    case actionTypes.DISABLE_AUCTION_TYPE_FINISH: {
      return {
        ...state,
        loading: false,
        disableSuccess: false,
      }
    }
    //Enable
    case actionTypes.SINGLE_ENABLE_AUCTION_TYPE_REQUEST: {
      return {...state, toggleLoading: true}
    }

    case actionTypes.SINGLE_ENABLE_AUCTION_TYPE_SUCCESS: {
      const changedData: any = action.payload?.data?.auctionType
      let newData = state?.data?.auctionType?.map((data) => {
        if (data?.id === changedData[0]?.id) {
          return {
            ...data,
            status: !data?.status,
          }
        } else {
          return data
        }
      })
      return {
        ...state,
        data: {...state, meta: state?.data?.meta, auctionType: newData},
        singleEnableSuccess: true,
        toggleLoading: false,
      }
    }

    case actionTypes.SINGLE_ENABLE_AUCTION_TYPE_FINISH: {
      return {
        ...state,
        singleEnableSuccess: false,
        toggleLoading: false,
      }
    }

    //Disable
    case actionTypes.SINGLE_DISABLE_AUCTION_TYPE_REQUEST: {
      return {...state, toggleLoading: true}
    }

    case actionTypes.SINGLE_DISABLE_AUCTION_TYPE_SUCCESS: {
      const changedData: any = action.payload?.data?.auctionType
      let newData = state?.data?.auctionType?.map((data) => {
        if (data?.id === changedData[0]?.id) {
          return {
            ...data,
            status: !data?.status,
          }
        } else {
          return data
        }
      })

      return {
        ...state,
        data: {...state, meta: state?.data?.meta, auctionType: newData},
        singleDisableSuccess: true,
        toggleLoading: false,
      }
    }

    case actionTypes.SINGLE_DISABLE_AUCTION_TYPE_FINISH: {
      return {
        ...state,
        singleDisableSuccess: false,
        toggleLoading: false,
      }
    }

    // sort
    case actionTypes.SORT_AUCTION_TYPE_START: {
      return {...state, loading: true}
    }

    case actionTypes.SORT_AUCTION_TYPE_SUCCESS: {
      return {
        ...state,
        sortAuctionTypeData: action?.payload,
        success: true,
        loading: false,
      }
    }

    case actionTypes.SORT_AUCTION_TYPE_FINISH: {
      return {
        ...state,
        loading: false,
        success: false,
      }
    }

    case actionTypes.SORT_AUCTION_TYPE_RESET: {
      return {
        ...state,
        loading: false,
        success: false,
        sortAuctionTypeData: [],
      }
    }

    default:
      return state
  }
}
